var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"numberShapeContainer"},[_c('img',{staticClass:"stars_bg",attrs:{"src":require("../../assets/stars_bg_memoryiq.svg")}}),_c('div',{ref:"imageContainer",staticClass:"photoFrame"})])])}
var staticRenderFns = []

export { render, staticRenderFns }